module.exports = __webpack_public_path__ + "img/cross.80551817.svg";